import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsMetricsComponent } from './transport-interventions-metrics.component';
import {DxChartModule} from 'devextreme-angular';
import {TransportInterventionsMetricsChartsModule} from '../transport-interventions-metrics-charts/transport-interventions-metrics-charts.module';



@NgModule({
  declarations: [TransportInterventionsMetricsComponent],
  imports: [
    CommonModule,
    DxChartModule,
    TransportInterventionsMetricsChartsModule
  ],
  exports: [TransportInterventionsMetricsComponent]
})
export class TransportInterventionsMetricsModule { }
